import { 
  FETCH_CHAT_USERS_REQUEST, 
  FETCH_CHAT_USERS_SUCCESS,
  FETCH_CHAT_USERS_FAILURE, 
} from "../../../constants/chat/Chat";
import { ChatUsers } from "../../../types/chat/Chat";

interface ChatState {
  chat_users: ChatUsers[];
  loading: boolean;
  success: boolean;
  error: string | null;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

const INIT_STATE: ChatState = {
  chat_users: [],
  loading: false,
  success: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0
  }
};

export default (state = INIT_STATE, action: any): ChatState => {
  switch (action.type) {
    case FETCH_CHAT_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_CHAT_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        chat_users: [...(state.chat_users || []), ...action.payload.data],
        pagination: action.payload.meta
      };

    case FETCH_CHAT_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}